var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Group } from '@/models/Group';
let PeriodeplanSelect = class PeriodeplanSelect extends Vue {
    get projectItems() {
        if (!this.group || !this.group.projects) {
            return [];
        }
        return this.group.projects;
    }
    onInput(projectId) {
        this.$emit('input', projectId || null);
    }
};
__decorate([
    Prop({ required: true }),
    __metadata("design:type", typeof (_a = typeof Group !== "undefined" && Group) === "function" ? _a : Object)
], PeriodeplanSelect.prototype, "group", void 0);
__decorate([
    Prop({ default: null }),
    __metadata("design:type", Object)
], PeriodeplanSelect.prototype, "value", void 0);
PeriodeplanSelect = __decorate([
    Component({
        inheritAttrs: false,
    })
], PeriodeplanSelect);
export default PeriodeplanSelect;
